import { IGenericJSON } from '../helpers/interface';
import { User } from './user';

export class Group {
  id: number;
  name: string;
  description: string;
  icon: string;
  source: string | null;
  createdAt: Date | null;
  updatedAt: Date | null;
  members: User[];
  managers: User[];

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.name = data['name'];
    this.description = data['description'];
    this.icon = data['icon'];
    this.source = data['source'];
    this.createdAt = data['created_at'] ? new Date(data['created_at']) : null;
    this.updatedAt = data['updated_at'] ? new Date(data['updated_at']) : null;
    this.members = User.digestResponse(
      (data['GroupMembers'] ?? []).map((member: any) => member.User),
    );
    this.managers = User.digestResponse(data['GroupManagers'] ?? []).map(
      (manager: any) => manager.User,
    );
  }

  public static digest(data: IGenericJSON): Group {
    return new Group(data);
  }

  public static digestResponse(data: IGenericJSON[]): Group[] {
    console.log(data);
    const ret: Group[] = [];

    data.forEach((u: IGenericJSON): void => {
      ret.push(this.digest(u));
    });
    console.log(ret);

    return ret;
  }
}
